import {TheBorderSymbol} from "./TheBorderSymbol";
import {TheBorder} from "../TheBorder";
import {TheBorderGameAssets} from "../TheBorderGameAssets";
import {gsap} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TheBorderStatics} from "../TheBorderStatics";

/**
 * Created by Jerker Nord on 2022-05-02.
 */

export class TheBorderXNudgeSymbol extends TheBorderSymbol {

    public static IDLE_ANIMATION: string = "Idle";
    public static IDLE_ANIMATION_SMALL: string = TheBorderXNudgeSymbol.IDLE_ANIMATION + "_s";
    public static LANDING_ANIMATION: string = "Landing";
    public static WIN_ANIMATION: string = "Win";
    public static WIN_ANIMATION_SMALL: string = TheBorderXNudgeSymbol.WIN_ANIMATION + "_s";

    private _landingAndIdleTL: gsap.core.Timeline;
    private _idleTL: gsap.core.Timeline;
    private _winTL: gsap.core.Timeline;

    constructor() {
        super();
        this.symbolName = "WR";
        this.createAnimations();
    }

    public setProps(): void {
        this.topLayerContainer.position.x = (TheBorderStatics.symbolWidth * this.reelId);
        this.topLayerContainer.position.y = this.y;

        this.topLayerContainer.addChild(this.splitLevelContainer, this.darkOverlayContainer);
        TheBorder.allReelsView.addChild(this.topLayerContainer);
    }

    public getLandingAndIdleAnimation(): gsap.core.Timeline {
        this.setProps();

        return this._landingAndIdleTL;
    }

    public getIdleAnimation(): void {
        this._idleTL = gsap.timeline();
        this._idleTL.add(() => {
            let animName: string = TheBorderXNudgeSymbol.IDLE_ANIMATION,
                yOffset: number = 0;

            if (this.sizeMultiplier === 0.5) {
                animName = TheBorderXNudgeSymbol.IDLE_ANIMATION_SMALL;
                yOffset = -25;
            }

            this._spineAnimation.y = yOffset;
            this.resetSpine();
            new SpineTween(this._spineAnimation, 0, animName, -1);
        });
    }

    public getWinAnimation(): gsap.core.Timeline {
        if (this._landingAndIdleTL && this._landingAndIdleTL.isActive()) {
            this._landingAndIdleTL.pause();
            this._landingAndIdleTL.kill();
        }
        if (this._idleTL && this._idleTL.isActive()) {
            this._idleTL.pause();
            this._idleTL.kill();
        }

        let animName: string = TheBorderXNudgeSymbol.WIN_ANIMATION,
            yOffset: number = 0;

        if (this.sizeMultiplier === 0.5) {
            animName = TheBorderXNudgeSymbol.WIN_ANIMATION_SMALL;
            yOffset = -25;
        }

        this._winTL = gsap.timeline();
        this._winTL.add(() => {
            this.setProps();
            this._spineAnimation.y = yOffset;
            this.resetSpine();
        });
        this._winTL.add(new SpineTween(this._spineAnimation, 0, animName));

        return this._winTL;
    }

    public turnOffSymbolSpine(): void {
        if (this._landingAndIdleTL && this._landingAndIdleTL.isActive()) {
            this._landingAndIdleTL.pause();
            this._landingAndIdleTL.kill();
        }
        if (this._idleTL && this._idleTL.isActive()) {
            this._idleTL.pause();
            this._idleTL.kill();
        }
        if (this._winTL && this._winTL.isActive()) {
            this._winTL.pause();
            this._winTL.kill();
        }
        this._spineAnimation.visible = false;

        this.addChild(this.splitLevelContainer);
    }

    public reset(): void {
        this.symbolName = "WR";
        super.reset();
    }

    private createAnimations(): void {
        this._spineAnimation = new PIXI.spine.Spine(TheBorder.assetLoader.getSpineAsset(TheBorderGameAssets.X_NUDGE_SPINE));
        this._spineAnimation.visible = false;
        this._spineContainer.addChild(this._spineAnimation);
        this.topLayerContainer.addChild(this._spineContainer);
        this.topLayerContainer.addChild(this.darkOverlayContainer);

        this._landingAndIdleTL = gsap.timeline({paused: true});
        this._landingAndIdleTL.add(() => {
            this.resetSpine();
        });
        this._landingAndIdleTL.add(new SpineTween(this._spineAnimation, 0, TheBorderXNudgeSymbol.LANDING_ANIMATION));
        this._landingAndIdleTL.add(() => {
            this.getIdleAnimation();
        });
    }

    private resetSpine(): void {
        if (!this._spineAnimation.visible) {
            this._spineAnimation.visible = true;
            this._spineAnimation.updateTransform();
        }
        this._spineAnimation.state.clearTracks();
        this._spineAnimation.skeleton.setSlotsToSetupPose();
        this._spineAnimation.skeleton.setToSetupPose();
        this._spineAnimation.state.setEmptyAnimation(0, 0);
    }
}